<div class="tour-container">
  <form [formGroup]="tourForm" (ngSubmit)="onSubmit()">
    <div class="col-12 d-flex">
      <div class="form-group col-6">
        <label for="customer_name">Customer Name</label>
        <input id="customer_name" type="text" pInputText formControlName="customer_name" />
        <div *ngIf="tourForm.controls['customer_name'].invalid && tourForm.controls['customer_name'].touched"
          class="error text-danger">
          <small class="text-danger">Customer Name is required.</small>
        </div>
      </div>
      <div class="form-group col-6">
        <label for="customer_email">Customer Email</label>
        <input id="customer_email" type="email" pInputText formControlName="customer_email" />
        <div *ngIf="tourForm.controls['customer_email'].invalid && tourForm.controls['customer_email'].touched"
          class="error text-danger">
          <small class="text-danger">Please enter a valid email address.</small>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex">
      <div class="form-group col-6">
        <label for="phone_number">Phone Number</label>
        <!-- <input id="phone_number" type="text" pInputText formControlName="phone_number" placeholder="+1234567890" (input)="enforcePrefix($event)" maxlength="16"/> -->
        <input id="phone_number" type="text" pInputText formControlName="phone_number" placeholder="xxx-xxx-xxxx" mask="000-000-0000" [validation]="true" />
        <div class="error text-danger" *ngIf="tourForm.controls['phone_number'].invalid && tourForm.controls['phone_number'].touched">
          <small class="text-danger" *ngIf="tourForm.get('phone_number')?.errors?.['required']">Phone Number is required.</small>
          <small class="text-danger"  *ngIf="tourForm.get('phone_number')?.errors?.['invalidUSPhone']">
            Kindly provide a valid US phone number in this formats:
            <code>000-000-0000</code>
            with a valid US area code.
          </small>
        </div>
      </div>
      <div class="form-group col-6">
        <label for="plan_name">Unit</label>
        <p-dropdown [options]="planNames" formControlName="plan_name" placeholder="Select Plan" id="plan_name"
        [filter]="!isModelUnit" filterBy="label" [showClear]="!isModelUnit" [disabled]="isModelUnit">
        </p-dropdown>
        <div *ngIf="tourForm.controls['plan_name'].invalid && tourForm.controls['plan_name'].touched"
          class="error text-danger">
          <small class="text-danger">Unit is required.</small>
        </div>
        <small class="text-muted" *ngIf="isModelUnit">This property schedules tours as Model Unit only.</small>
      </div>
    </div>
    <div class="col-12 d-flex">
      <div class="col-6">
        <div class="form-group">
          <label for="tour_date">Date</label>
          <p-calendar type="Date" id="tour_date" formControlName="date"
            [minDate]="minDate" [maxDate]="maxDate" dateFormat="mm/dd/yy" [showIcon]="true"
            [showButtonBar]="true" placeholder="Date" [iconDisplay]="'input'"
            [readonlyInput]="isEditMode" inputStyleClass="p-inputtext"
            (onSelect)="goToTimeSelection(tourForm.get('date')?.value)">
          </p-calendar>
          <div *ngIf="tourForm.controls['date'].invalid && tourForm.controls['date'].touched" class="error text-danger">
            <small class="text-danger">Scheduled Date is required.</small>
          </div>
        </div>
      </div>

      <div class="form-group col-6">
        <label for="tour_time">Time</label>
        <div class="time-slot-grid mt-2">
          <p-dropdown
            id="tour_time"
            [options]="availableTimes"
            formControlName="time"
            placeholder="Select Time"
            [showClear]="true"
            (onChange)="getAvailableResidents()">
          </p-dropdown>
        </div>
        <div class="error text-danger">
            <span *ngIf="!selectedDate && availableTimes.length === 0">
              Please select a date first.
            </span>
        </div>
        <!-- Validation -->
        <div *ngIf="tourForm.controls['time'].invalid && tourForm.controls['time'].touched" class="error text-danger">
          <small>Scheduled Time is required.</small>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex">
      <div class="form-group col-6">
        <label for="user_id">Assign to</label>
        <p-dropdown [options]="residentOptions" formControlName="user_id" placeholder="Select Resident"
          [showClear]="true" filter="true"></p-dropdown>
      </div>
      <div class="form-group col-6">
        <label for="lockbox_code">Lockbox Code</label>
        <input id="lockbox_code" type="text" pInputText maxlength="10" formControlName="lockbox_code" />
        <!-- <div *ngIf="tourForm.controls['lockbox_code'].invalid && tourForm.controls['lockbox_code'].touched"
          class="error text-danger">
          <small class="text-danger">Lockbox Code is required and must be exactly 10 digits.</small>
        </div> -->
      </div>
    </div>
    <div class="d-flex justify-content-end mt-2 p-1">
      <p-button type="button" label="Cancel" class="secondary-btn" (click)="cancelAddFollowup()"></p-button>
      &nbsp;
      <p-button type="submit" [disabled]="tourForm.invalid || isSubmitting"
      class="primary-btn" [label]="!isSubmitting ? buttonLabel + ' Tour' : 'Submitting...'"></p-button>
    </div>
  </form>
</div>
<p-toast></p-toast>
